export const environment = {
  apiMain: 'https://api-v1.colegiosmonserrat.info', //MONSERRAR
  // apiMain: 'https://cruzsaco-api-v1.colegiosmonserrat.info', //CRUZ SACO
  contactAccount: 'support@yakhana.com',
  deepLink: 'yakhana://'
};